import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import useUserState from "../hooks/useUserState";
import Axios from "axios";
import useBDocTranslator from "../hooks/useBDocTranslator";
import { Button, TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    boxShadow: theme.shadows[8],
    padding: theme.spacing(4),
    width: "90%",
    maxWidth: 520,
    maxHeight: "90vh",
    overflowY: "auto",
  },
  header: {
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& h3": {
      margin: 0,
      fontSize: "1.125rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  },
  actions: {
    display: "flex",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(3),
  },
}));

export default function BackgroundForm(props) {
  const classes = useStyles();
  const [bg, setBg] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const userLocalState = useUserState();
  const { t } = useBDocTranslator();

  //Method creates a new health measurement record in the database
  const createBg = () => {
    if (!bg) return;

    Axios.post(
      `${process.env.REACT_APP_API_URL_BASE}/bg/create`,
      {
        content: bg,
        type: props.type,
        patient_id: props.patientId,
      },
      {
        headers: { Authorization: "Bearer " + userLocalState[0].jwt },
      },
    )
      .then((res) => {
        props.handleRefreshData();
        props.handleClose();
      })
      .catch((error) => {
        console.log(error);
        setResponseMessage("Error " + error);
      });
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        // className="flex items-center justify-center overflow-y-auto"
        open={props.open}
        onClose={() => {
          props.handleClose();
          setResponseMessage("");
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          {
            <div className={classes.paper}>
              <div className={classes.header}>
                <h3>{t(props.title)}</h3>
              </div>
              <TextField
                id="background-content"
                label={t(props.title)}
                variant="outlined"
                fullWidth
                value={bg}
                onChange={(e) => setBg(e.target.value)}
                required
              />
              {responseMessage && (
                <p className="text-danger font-weight-bold mt-2">
                  {responseMessage}
                </p>
              )}
              <div className={classes.actions}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={createBg}
                  disabled={!bg}
                  style={{ flex: 1 }}
                >
                  {t("Save")}
                </Button>
                <Button
                  variant="outlined"
                  color="default"
                  onClick={props.handleClose}
                  style={{ flex: 1 }}
                >
                  {t("Cancel")}
                </Button>
              </div>
            </div>
          }
        </Fade>
      </Modal>
    </div>
  );
}
